import React from "react"


import ThemeWrapper from "./ThemeWrapper"
import Nav from "./Nav"
import MobileNav from "./MobileNav"
import Footer from "./Footer"
import SEO from "./SEO"



import "../sass/styles.scss"


export default function Layout({ children, cssClass, title, description }) {
  
  return (
    <ThemeWrapper>
      <SEO title={title} description={description} />
      
      <div id="page" className={cssClass}>
        <Nav />
        <main>{children}</main>
        <Footer />
      </div>
      <MobileNav />
    </ThemeWrapper>
  )
}
